import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-system",
  "use": "icon-soc-system-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-system\">\r\n<g transform=\"translate(4.625 -44.924) scale(0.990968)\">\r\n<path d=\"M448 128h128v112l80 48 80-48 90 90-48 80 48 80-112 64v128l112 64-48 80 48 80-90 90-80-48-80 48H448l-80-48-80 48-90-90 48-80-48-80 112-64V512l-112-64 48-80-48-80 90-90 80 48 80-48V128zm64 256a128 128 0 1 0 0 256 128 128 0 0 0-256z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-system.svg
// module id = +q6G
// module chunks = 478